
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (sectionId: string) => {
    // Se não estamos na página inicial, navegar para ela primeiro
    if (location.pathname !== '/') {
      navigate('/');
      // Aguardar um pouco para a página carregar antes de fazer o scroll
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      // Se já estamos na página inicial, fazer scroll direto
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsMenuOpen(false);
  };

  const handleHomeClick = () => {
    if (location.pathname !== '/') {
      navigate('/');
    } else {
      scrollToSection('home');
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-md border-b border-gray-800">
      <div className="container mx-auto px-6 py-3">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img 
              src="https://static.readdy.ai/image/54e10434a90951f6daafe5abdc38c83e/ac77273049b634ecee5390e4c5c80466.png" 
              alt="Take Lead Logo" 
              className="h-9 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={handleHomeClick}
              className="text-gray-300 hover:text-white transition-colors cursor-pointer"
            >
              Início
            </button>
            <button 
              onClick={() => scrollToSection('channels')}
              className="text-gray-300 hover:text-white transition-colors cursor-pointer"
            >
              Canais
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="text-gray-300 hover:text-white transition-colors cursor-pointer"
            >
              Serviços
            </button>
            <button 
              onClick={() => scrollToSection('differentials')}
              className="text-gray-300 hover:text-white transition-colors cursor-pointer"
            >
              Diferenciais
            </button>
            <button 
              onClick={() => scrollToSection('process')}
              className="text-gray-300 hover:text-white transition-colors cursor-pointer"
            >
              Processo
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-gray-300 hover:text-white transition-colors cursor-pointer"
            >
              Contato
            </button>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Button 
              onClick={() => scrollToSection('contact')}
              variant="primary"
              icon={<i className="ri-rocket-line"></i>}
            >
              Acelere suas Vendas
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-white p-2"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-800">
            <nav className="flex flex-col space-y-4 mt-4">
              <button 
                onClick={handleHomeClick}
                className="text-gray-300 hover:text-white transition-colors text-left cursor-pointer"
              >
                Início
              </button>
              <button 
                onClick={() => scrollToSection('channels')}
                className="text-gray-300 hover:text-white transition-colors text-left cursor-pointer"
              >
                Canais
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className="text-gray-300 hover:text-white transition-colors text-left cursor-pointer"
              >
                Serviços
              </button>
              <button 
                onClick={() => scrollToSection('differentials')}
                className="text-gray-300 hover:text-white transition-colors text-left cursor-pointer"
              >
                Diferenciais
              </button>
              <button 
                onClick={() => scrollToSection('process')}
                className="text-gray-300 hover:text-white transition-colors text-left cursor-pointer"
              >
                Processo
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="text-gray-300 hover:text-white transition-colors text-left cursor-pointer"
              >
                Contato
              </button>
              <Button 
                onClick={() => scrollToSection('contact')}
                variant="primary"
                className="mt-4"
                icon={<i className="ri-rocket-line"></i>}
              >
                Acelere suas Vendas
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
